import casify from './casify';

export function camelifyString(string) {
  return string.replace(/_([a-z0-9])/g, (match, firstCharacter) => firstCharacter.toUpperCase());
}

export const camelify = casify(camelifyString);

export default camelify;
